import request from '@/utils/request';
import { orderServiceV1 } from '@/config/apiPrefix.config';

// 获取合同列表
export const getContractList = (data) => request(`${orderServiceV1}/contract/list`, {
  params: data,
});

// 获取合同详情
export const getContractDetail = (data) => request(`${orderServiceV1}/contract/${data.id}`);

export const actions = {
  // 申请重启合同
  applyRestart: (data) => request(`/order_svc/api/v1/contract/${data.id}/apply_for_restart`, {
    method: 'put',
  }),
  // 拒绝合同
  reject: (data) => request(`/order_svc/api/v1/contract/${data.id}/deny`, {
    method: 'put',
  }),
  // 中止合同
  suspend: (data) => request(`/order_svc/api/v1/contract/${data.id}/suspend`, {
    method: 'put',
  }),
  // 同意审批
  pass: (data) => request(`/order_svc/api/v1/contract/${data.id}/approve`, {
    method: 'put',
  }),
  // 重启合同
  restart: (data) => request(`/order_svc/api/v1/contract/${data.id}/restart`, {
    method: 'put',
  }),
  // 终止合同
  stop: (data) => request(`/order_svc/api/v1/contract/${data.id}/finish`, {
    method: 'put',
  }),
};

// 创建免费使用合同
export const createFreeContract = (data) => request(`${orderServiceV1}/contract/create_free`, {
  body: data,
  method: 'post',
});

// 创建月结合同
export const createMonthContract = (data) => request(`${orderServiceV1}/contract/create_monthly`, {
  body: data,
  method: 'post',
});

// 创建预付合同
export const createPrePayContract = (data) => request(`${orderServiceV1}/contract/create_prepaid`, {
  body: data,
  method: 'post',
});

// 验证月结合同开始日期
export const validateMonthly = (data) => request(`${orderServiceV1}/contract/validate_monthly`, {
  body: data,
  method: 'post',
});

// 验证免费试用
export const validateFree = (data) => request(`${orderServiceV1}/contract/validate_free`, {
  body: data,
  method: 'post',
});

// 修改合同
export const updateContract = (data) => request(`${orderServiceV1}/contract/${data.id}/modify`, {
  body: data,
  method: 'put',
});

// 变更合同
export const updateMonthContract = (data) => request(`${orderServiceV1}/contract/${data.id}/change_monthly`, {
  body: data,
  method: 'put',
});
